module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000301-714ab5cb51a7550538659ac0e62253f2.pdf";